import React, { Children } from "react";
import HorizontalRule from "../../Rule/Horizontal";

type Props = { children: React.ReactNode; title: string };

export default function HistoryDetailBlock({ children, title }: Props) {
  return (
    <div>
      <HorizontalRule className="bg-black" margin="0" />
      <div>
        <div className="pt-[30px] text-lg font-medium pb-5">{title}</div>
        {children}
      </div>
    </div>
  );
}
